export const isAppTypeUtil = (input) => {
    const apps = [
        "analytics",
        "care4",
        "dataStation",
        "digitalCare",
        "ecdVvt",
        "hr",
        "hrSalaryAdmin",
        "identity",
        "jo",
        "karify",
        "kis",
        "learning",
        "octopus",
        "one",
        "planning",
        "sdb",
        "salary",
        "user",
    ];
    return apps.includes(input);
};
